import logo from './logo.svg';
import './App.css';
import Component from './components/Section';

function App() {
  return (
    <div className="App">
      {/* NAVBAR */}
      <Component />
    </div>
  );
}

export default App;
